import Divider from '@/components/common/Divider'
import { hexWithOpacity } from '@/utils/color'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Flex, Icon, Title } from '@collable/ui'

const SignUpProgress = () => {
  return (
    <Container gap={12} justifyContent="center" alignItems="center">
      <Step status="complete" step={1}>
        소셜 가입하기
      </Step>
      <Divider color="lineNormal" width={40} />
      <Step status="current" step={2}>
        본인 인증
      </Step>
    </Container>
  )
}

const Step = ({
  step,
  children,
  status,
}: {
  step: number
  status: 'complete' | 'current'
  children: React.ReactNode
}) => {
  return (
    <Flex gap={12} alignItems="center">
      <StepIcon isCompleted={status === 'complete'} isCurrent={status === 'current'}>
        {status === 'complete' ? (
          <Icon name="checkBig" iconColor="commonWhite" iconSize={20} />
        ) : (
          step
        )}
      </StepIcon>
      <Title
        size="subTitle3"
        fontWeight="bold"
        color={status === 'current' ? 'labelNormal' : 'labelDisable'}
        as="h4"
      >
        {children}
      </Title>
    </Flex>
  )
}

export default SignUpProgress

const Container = styled(Flex)`
  padding: 28px;
  background-color: ${({ theme }) => theme.common.commonWhite};
  border-radius: 20px;
  width: 600px;
`

const StepIcon = styled.div<{ isCompleted: boolean; isCurrent: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: ${({ theme }) => theme.typography.subTitle3.fontSize};
  font-weight: 500;
  font-weight: ${({ theme }) => theme.typography.subTitle3.lineHeight};

  ${({ isCompleted, isCurrent, theme }) => {
    if (isCompleted)
      return css`
        background-color: ${theme.status.statusPositive};
      `
    if (isCurrent)
      return css`
        border: 2px solid ${theme.primary.primaryNormal};
        background-color: ${hexWithOpacity('primaryNormal', 0.05)};
        color: ${theme.primary.primaryNormal};
      `

    return css`
      border: 2px solid ${theme.label.labelDisable};
      background-color: ${hexWithOpacity('fillStrong', 0.05)};
      color: ${theme.label.labelDisable};
    `
  }};
`
